import React, { useState, useEffect } from "react";
import PropTypes from 'prop-types'
import styles from "./FullNowPlaying.module.css";
// import {getLyrics} from "genius-lyrics-api"

const FullNowPlayingCompNew = (props) => {
  const [track, setTrack] = useState("");
  const [artists, setArtists] = useState([]);
  //eslint-disable-next-line
  const [trackAristString, setTrackArtistString] = useState("");
  const [album, setAlbum] = useState("");
  const [cover, setCover] = useState("");
  //eslint-disable-next-line
  const [duration, setDuration] = useState(0);
  //eslint-disable-next-line
  const [progress, setProgress] = useState(0);
  //eslint-disable-next-line
  const [progressInPercent, setProgressInPercent] = useState(0);
  //eslint-disable-next-line
  const [lyrics, setLyrics] = useState("");

  useEffect(() => {
    const getNowPlaying = async () => {
      const nowPlaylyingRes = await fetch(
        "https://api.spotify.com/v1/me/player/currently-playing",
        {
          method: "GET",
          headers: {
            Authorization: "Bearer " + sessionStorage.getItem("accessToken")
          }
        }
      );
      let nowPlaylyingData = await nowPlaylyingRes.json();
      // console.log(nowPlaylyingData);

      setTrack(nowPlaylyingData.item.name);
      setArtists(
        nowPlaylyingData.item.artists.map((artist, i) =>
          i < Object.keys(nowPlaylyingData.item.artists).length - 1
            ? artist.name
            : artist.name
        )
      );
      setTrackArtistString(
        nowPlaylyingData.item.name +
          ";" +
          nowPlaylyingData.item.artists["0"].name
      );
      setAlbum(nowPlaylyingData.item.album.name);
      setCover(nowPlaylyingData.item.album.images[0] !== undefined ? nowPlaylyingData.item.album.images[0].url : "");
      setDuration(Math.ceil(nowPlaylyingData.item.duration_ms / 1000));
      setProgress(Math.ceil(nowPlaylyingData.progress_ms / 1000));
      setProgressInPercent(
        Math.round(
          Math.round(
            (nowPlaylyingData.progress_ms / nowPlaylyingData.item.duration_ms) *
              100
          )
        )
      );
    };

    getNowPlaying();

    setInterval(() => {
      getNowPlaying();
    }, 5000);
  }, []);

  useEffect(() => {
    //eslint-disable-next-line
    const getLyrics = async () => {
      const lyricsRes = await fetch(
        `https://baccstein.ddns.net/api/lyrics?trackName=${encodeURIComponent(
          trackAristString.split(";")[0]
        )}&trackArtist=${encodeURIComponent(trackAristString.split(";")[1])}`
      );
      const lyricsData = await lyricsRes.json();
      const regex = /(<(?!(?:br))[^>]+>)/ig
      const regex2 = /(<br>)/ig
      console.log(lyricsData.message)
      console.log(lyricsData.message.lyrics.replace(regex, "").replace(regex2, "\n"));
      setLyrics(lyricsData.message.lyrics.replace(regex, "").replace(regex2, "\n"));
    };

    try {
      if (trackAristString) {
        getLyrics();
      }
    } catch (error) {
      console.error(error);
    }
    // console.log(artistsString.split(",")[0])
  }, [trackAristString]);

  useEffect(() => {
    console.log(trackAristString);
  }, [trackAristString]);

  return (
    <div className={styles.main}>
      <h1 className={styles.header}>Now Playing:</h1>
      <div className={styles.inner}>
        <div className={styles.track}>
          <div className={styles.trackUpper}>
            <img className={styles.trackCover} src={cover} alt="cover" />
            <p className={styles.trackName}> {track} </p>
            <p className={styles.trackArtist}>
              {artists
                .toString()
                .split(",")
                .map((artist, i) => {
                  if (i < Object.keys(artists).length - 1) return artist + ", ";
                  else return artist;
                })}
            </p>
            <p className={styles.trackAlbum}> {album} </p>
          </div>

          <div className={styles.trackLower}></div>
        </div>

        <div className={styles.lyrics}>
          <h2 className={styles.lyricsHeader}>Lyrics:</h2>
          <div className={styles.lyricsParent}>
            <br/>
            <pre className={styles.lyricsText}>{lyrics}</pre>
          </div>
        </div>
      </div>
    </div>
  );
};

FullNowPlayingCompNew.propTypes = {
  accessToken: PropTypes.string.isRequired
}

export default FullNowPlayingCompNew;
